// ##### 25-04-30 Komarov
import axios from 'axios';
// ##### Komarov 2025-07-12
import React, { useEffect, useRef, useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import ReCAPTCHA from 'react-google-recaptcha';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { register } from '../../../Redux/actions/auth';

// ##### 25-04-18 Komarov
// Custom email validator
const isValidEmail = email => {
  // RFC 5322 standard email regex pattern
  const emailPattern =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return emailPattern.test(email);
};

// ##### Komarov 2025-07-14
const Register = () => {
  // ##### Komarov 2025-07-12
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const captchaRef = useRef(null);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    username: '',
    email: '',
    password: '',
    promocode: '',
  });

  const [errors, setErrors] = useState({});
  const [successful, setSuccessful] = useState(false);
  const [captchaNotSolved, setCaptchaNotSolved] = useState(false);

  const { message } = useSelector(state => state.message);
  const locale = useSelector(state => state.language);
  const dispatch = useDispatch();

  const validateForm = () => {
    const newErrors = {};

    // Username validation
    if (!formData.username.trim()) {
      newErrors.username = 'This field is required!';
    } else if (formData.username.length < 3 || formData.username.length > 20) {
      newErrors.username = 'The username must be between 3 and 20 characters.';
    } else if (!formData.username.match(/^[a-z][a-z0-9]*$/i)) {
      newErrors.username =
        'The username must contain only latin characters or numbers (allowed from second character).';
    }

    // Email validation with our custom validator
    if (!formData.email.trim()) {
      newErrors.email = 'This field is required!';
    } else if (!isValidEmail(formData.email)) {
      newErrors.email = 'This is not a valid email.';
    }

    // Password validation
    if (!formData.password) {
      newErrors.password = 'This field is required!';
    } else if (formData.password.length < 6 || formData.password.length > 40) {
      newErrors.password = 'The password must be between 6 and 40 characters.';
    }

    // First name validation
    if (!formData.firstName) {
      newErrors.firstName = 'This field is required!';
    } else if (
      formData.firstName.length < 3 ||
      formData.firstName.length > 20
    ) {
      newErrors.firstName =
        'The first name must be between 3 and 20 characters.';
    }

    // Last name validation
    if (!formData.lastName) {
      newErrors.lastName = 'This field is required!';
    } else if (formData.lastName.length < 3 || formData.lastName.length > 20) {
      newErrors.lastName = 'The last name must be between 3 and 20 characters.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: '',
      }));
    }
  };

  const handleRegister = async e => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    if (
      process.env.REACT_APP_IS_RECAPTCHA_ONLINE === 'true' &&
      process.env.REACT_APP_RECAPTCHA_SITE &&
      process.env.REACT_APP_RECAPTCHA_SERVER
    ) {
      const token = captchaRef.current.getValue();
      captchaRef.current.reset();
      setCaptchaNotSolved(true);

      try {
        const res = await axios.post(
          `${process.env.REACT_APP_URL}/token_check`,
          { token },
          {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          }
        );

        if (res.data === 'Human 👨 👩') {
          setCaptchaNotSolved(false);
          await submitRegistration();
        } else {
          setCaptchaNotSolved(true);
        }
      } catch (error) {
        // ##### 25-04-30 Komarov
        console.error(error);
      }
    } else {
      await submitRegistration();
    }
  };

  const submitRegistration = async () => {
    try {
      await dispatch(
        register(
          formData.firstName,
          formData.lastName,
          formData.username,
          formData.email,
          formData.password,
          formData.promocode,
          locale
        )
      );
      setSuccessful(true);
    } catch (error) {
      setSuccessful(false);
    }
  };

  return (
    <div className="col-md-12" data-component="Register">
      <div
        className="card card-container"
        style={{ backgroundColor: '#f7f7f7' }}
      >
        <img
          src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
          alt="profile-img"
          className="profile-img-card"
        />

        <form onSubmit={handleRegister}>
          {!successful && (
            <div>
              {[
                'firstName',
                'lastName',
                'username',
                'email',
                'password',
                'promocode',
              ].map(field => (
                <div className="form-group" key={field}>
                  <label htmlFor={field}>
                    {field.charAt(0).toUpperCase() + field.slice(1)}
                    {field !== 'promocode' && <sup>*</sup>}
                  </label>
                  <input
                    type={field === 'password' ? 'password' : 'text'}
                    className={`form-control ${errors[field] ? 'is-invalid' : ''}`}
                    name={field}
                    value={formData[field]}
                    onChange={handleInputChange}
                  />
                  {errors[field] && (
                    <div className="alert alert-danger" role="alert">
                      {errors[field]}
                    </div>
                  )}
                </div>
              ))}

              {process.env.REACT_APP_IS_RECAPTCHA_ONLINE === 'true' &&
                process.env.REACT_APP_RECAPTCHA_SITE &&
                process.env.REACT_APP_RECAPTCHA_SERVER && (
                  <>
                    <ReCAPTCHA
                      sitekey={process.env.REACT_APP_RECAPTCHA_SITE}
                      ref={captchaRef}
                    />
                    {captchaNotSolved && (
                      <Alert variant="danger">Please solve a CAPTCHA!</Alert>
                    )}
                  </>
                )}

              <div className="form-group">
                <button type="submit" className="btn btn-primary btn-block">
                  Sign Up
                </button>
              </div>

              <div className="form-group text-center">
                Have an account already?
              </div>

              {/*##### 25-04-21 Komarov*/}
              <div className="form-group text-center">
                <Link to={`/${locale}/profile/?name=sign_in&spid=198`}>
                  Login
                </Link>
              </div>
            </div>
          )}

          {message && (
            <div className="form-group">
              <div
                className={
                  successful ? 'alert alert-success' : 'alert alert-danger'
                }
                role="alert"
              >
                {message}
              </div>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

// ##### 25-05-02 Komarov
export default Register;
